import { RouteFunctionParams, TileRoleRoute } from '@/types'
import { faStoreAlt } from '@fortawesome/free-solid-svg-icons'
import { Roles } from '@/auth/azure/Roles'
import React from 'react'
import { useQsAdminApiManager } from '@/auth/api/qsadminapiManager'
import { defer, LoaderFunction } from 'react-router-typesafe'
import CostCenter from '@/routes/admin/users/costcenter/CostCenter'

export const costCentersEditorRouteLoader = (async ({ request, params }: RouteFunctionParams) => {
  const qsAdminApi = useQsAdminApiManager.getState().service

  const getReparti = qsAdminApi.reparto().query((builder, reparto) => {
    builder.select('id', 'nome')
    builder.orderBy(reparto.nome.asc())
  })

  const getCentriCosto = qsAdminApi.centro_costo().query((builder, centroCosto) => {
    builder.select('id', 'nome')
    builder.orderBy(centroCosto.nome.asc())
  })

  return defer({ title: 'Editazione centri di costo', getReparti, centriCosto: await getCentriCosto })
}) satisfies LoaderFunction

export const CostCenterRoute: TileRoleRoute = {
  path: 'centrocosto',
  text: 'Centro Costo',
  loader: costCentersEditorRouteLoader,
  faIcon: faStoreAlt,
  element: <CostCenter />,
  handle: {
    crumb: () => ({
      label: 'Centro Costo',
      icon: faStoreAlt,
    }),
  },
  mainMenuRoute: false,
  tile: true,
  allowedRoles: [Roles.GlobalAdministrator, Roles.Administrator],
}
